/**
 * Parse a saved interview transcript ("[ts] Interviewer:/Candidate: …" lines, with a
 * leading "#"-comment header) into chat turns: [{ role, text }].
 *
 * Shared by the live chat page (to rebuild history on resume) and the completion page
 * (to render the bubble transcript). Header/comment lines are skipped; wrapped
 * continuation lines are appended to the previous turn.
 */
// Matches the PDF/recruiter-modal contract (report_pdf._parse_turns, MeetingAnalysisModal.parseLine):
// the timestamp is OPTIONAL, matching is case-INSENSITIVE, and AI lines may be labeled with the persona
// (Wiza/AI/Assistant) or the candidate as Applicant/User. The old strict regex (bracket required, only
// Interviewer|Candidate, case-sensitive) silently folded any such line into the previous bubble, so AI
// questions that the PDF kept "disappeared" from the app result screen.
const LINE_RE = /^(?:\[[^\]]*\]\s*)?(interviewer|wiza|ai|assistant|candidate|applicant|user)\s*:\s*(.*)$/i;
const CANDIDATE_LABELS = new Set(['candidate', 'applicant', 'user']);

export const parseTranscript = (text) => {
  if (!text) return [];
  const turns = [];
  text.split('\n').forEach((line) => {
    const t = line.trim();
    if (!t || t.startsWith('#')) return;
    const m = t.match(LINE_RE);
    if (m) {
      const role = CANDIDATE_LABELS.has(m[1].toLowerCase()) ? 'candidate' : 'interviewer';
      turns.push({ role, text: m[2] });
    } else if (turns.length) {
      turns[turns.length - 1].text += ` ${t}`; // wrapped line
    }
  });
  return turns;
};

export default parseTranscript;
